module.exports = __webpack_public_path__ + "static/media/news48.6fdf0a7c.jpg";